import hu from './hu';
import en from './en';
import cs from './cs';
import sk from './sk';
import xx from './xx';

export default { hu, en, xx, cs, sk };
